export class PackingBomRequest{
     unitId?:number;
     saleOrderId?:number;
     fromDate?:Date;
     toDate?:Date;
}